import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSettings } from '../app.settings';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../providers/session.service';
import { SmsApiSessionService } from '../providers/sms-api-session.service';
import { ModalLoginComponent } from '../components/modal-login/modal-login.component';
import { User } from '../models/user';

@Injectable()
export class ModalAuthGuard implements CanActivate {
 
    constructor(private router: Router, private sessionService: SessionService, private smsApiSessionService: SmsApiSessionService, private modal: NgbModal) { }
 
    canActivate() {

        return this.smsApiSessionService.getSession().then(user => {
            console.log(user);
            if(user.enabled){
                console.log("User is enabled, so carry on!");
                this.sessionService.setUser(user);
                return true;
            } else {
                console.log("User ain't enabled, whoa big fella!");
                return this.getSession("");            
           }
        }).catch(error => {
            return this.getSession(error);            
        });
        
    }

    getSession(error_message_if_any: String): Promise<boolean> {
      return new Promise((resolve, reject) => {
                        // not logged in so display Log In Dialog
                let modal_login = this.modal.open(ModalLoginComponent, {size: 'lg'});
                modal_login.componentInstance.user_selected$.subscribe(user => {
                if(user.enabled){
                    modal_login.close();
                    resolve(true);
                } else {
                    modal_login.componentInstance.setError("Error logging in");
                }
            }, error => {
                modal_login.componentInstance.setError(error);
            });
    });
  }

}